import PaginatedList from "#root/components/paginated-list";
import type { ReactNode } from "react";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { corporateActionCollection } from "#root/schema/platform/reference-data";
import PageLayout from "./layout";

const title = (
  <Fragment>
    Corporate Actions{" "}
    <Link className="button" to="/admin/platform/reference/corporateAction/new">
      New Corporate Action
    </Link>
  </Fragment>
);

export default function CorporateActionPage(): ReactNode {
  return (
    <PageLayout title="Reference Platform - Corporate Action">
      <PaginatedList title={title} collection={corporateActionCollection}>
        {({ rows }) => (
          <table>
            <thead>
            <tr>
              <th>Date</th>
              <th>Symbol</th>
              <th>Source</th>
              <th>Event Type</th>
              <th>Value</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            {rows.map(({ id, eventDate, symbol, source, eventType, value }) => (
              <tr key={id}>
                <td>{eventDate}</td>
                <td>{symbol}</td>
                <td>{source}</td>
                <td>{eventType}</td>
                <td>{value}</td>
                <td>
                  <Link to={`/admin/platform/reference/corporateAction/${id}`}>Edit</Link>
                </td>
              </tr>
            ))}
            </tbody>
          </table>
        )}
      </PaginatedList>
    </PageLayout>
  );
}
